import { FC, Fragment, useReducer } from 'react';

import { Copy, FileText } from 'lucide-react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { CheaterModel } from 'v2/types/CheaterModel';
import { copyText } from 'v2/utils';

interface CheaterScriptColumnProps {
  cheater: CheaterModel;
}

export const CheaterScriptColumn: FC<CheaterScriptColumnProps> = ({ cheater }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const handleCopy = () => {
    copyText(cheater.script);
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<FileText width={18} height={18} />} variant="outlined">
        Show Script
      </Button>

      <Dialog open={isOpen} onClose={setOpen} scroll="paper" maxWidth="sm" fullWidth>
        <DialogTitle>Cheater's Script</DialogTitle>

        <DialogContent>
          <code>{cheater.script}</code>
        </DialogContent>

        <DialogActions>
          <Button onClick={setOpen} variant="outlined" color="error">
            Close
          </Button>

          <Button startIcon={<Copy width={18} />} onClick={handleCopy} variant="outlined">
            Copy
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
